import { StrictMode, Suspense } from "react";
import { Analytics } from "@vercel/analytics/react";
import ReactDOM from "react-dom/client";

import { posthog } from "@/lib/posthog";
import { sentry } from "@/lib/sentry";

import { Loading } from "@/components/module/Loading";

import "@/lib/i18n";

import { App } from "./App.tsx";
import "./index.css";

sentry.init();
posthog.init();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
    <Analytics />
  </StrictMode>
);
